import axios from "axios";
import config from "../../../config";

const SYNCHROEU_URL = config.SYNCHROEU_URL;

// Optional: central axios instance
const api = axios.create({
  baseURL: SYNCHROEU_URL,
  headers: {
    accept: "application/json",
  },
});

// POST /scenarios/{id}/activate
export const activateScenario = (scenarioId) => {
  return api.post(`/scenarios/${scenarioId}/activate`);
};

// POST /scenarios/{id}/deactivate
export const deactivateScenario = (scenarioId) => {
  return api.post(`/scenarios/${scenarioId}/deactivate`);
};

// DELETE /scenarios/{id}
export const deleteScenario = (scenarioId) => {
  return api.delete(`/scenarios/${scenarioId}`);
};

export const tmpxScenario = (scenarioId) => {
  return api.post(`/scenarios/tmpx/${scenarioId}/publish`);
};